import React,{useEffect, useState} from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import Reporte from '../../../componentes/reporte';
import Recibopdf from './pdf/recibonuevo';
import Facturapdf from './pdf/factura';
import { Ver_Valores } from '../../../constantes';
import Cuerpo from '../../../componentes/herramientas/cuerpo';

export default function Enviado(props) {
    const [documento, setDocumento] = useState('');
   
    useEffect(()=>{
        const Inicio = async() =>{
           const resultado = Recibopdf(props.Recibo)
           setDocumento(resultado)
        }
        // Inicio();
        return ()=>{}
    },[props])
    
    const Recibo = props.Recibo ? props.Recibo : Ver_Valores().datosActuales.Recibo;
    const Bloques = {
        "Recibo":Recibo 
                ?   <Reporte  datos={Recibo} reporte={Recibopdf} sizePagina= {{width:612, height:396}} />
                :   null,
        "Factura":Recibo 
                ? <Reporte  datos={{...Recibo}} reporte={Facturapdf} sizePagina= {{width:612, height:396}} />
                : null
    }
    return (
        <Box sx={{ textAlign:'left' }}>
            <Typography variant="h5" gutterBottom component="div">
                {Recibo
                    ? `Pago realizado con exito, Numero de Recibo: ${Recibo ? Recibo.valores.recibo: '0000' }`
                    :   `Pago enviado`
                }
            </Typography>
            
            {/* <embed src={`${documento}#view=Fit&toolbar=1&navpanes=1&scrollbar=1`} type="application/pdf" width="100%" height={window.innerHeight * 0.65} /> */}
            {/* {Recibo 
                ?   <Reporte  datos={Recibo} reporte={Recibopdf} sizePagina= {{width:612, height:396}} />
                :   null
            } */}
            <Cuerpo Bloques={Bloques} Config={Ver_Valores().config} />
        </Box>
    );
}
